import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import SiteNavItem from './SiteNavItem';
import get from 'lodash.get';

import styles from './SiteNav-style.scss';

const SiteNav = props => (
    <div className={styles.wrapper}>
        <div className={styles.items}>
            {(get(props.navigation, 'modules') || []).map(module => {
                return <SiteNavItem key={module.serviceId} {...module} />;
            })}
        </div>
    </div>
);

SiteNav.propTypes = {
    navigation: PropTypes.object,
};

export default createFragmentContainer(SiteNav, {
    navigation: graphql`
        fragment SiteNav_navigation on Navigation {
            modules {
                isVertical
                serviceId
                name
                url
                items {
                    serviceId
                    name
                    type
                    items {
                        serviceId
                        name
                        url
                        visible
                    }
                }
            }
        }
    `,
});
